import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";
import { RentActions } from "../actions/rent.actions";
import { Store } from "@ngrx/store";
import { Booking } from "src/app/public/rent/models/booking.model";
import { RentService } from "src/app/public/rent/services/rent.service";

@Injectable()
export class RentApiEffects{

    constructor(
        private rentService: RentService,
        private actions$: Actions,
        private store: Store
    ){}
    
    addNewBooking$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(RentActions.bookingNewSubmit),
            concatMap( (action) => {
                return this.rentService
                    .addNewBooking (action.booking)
                    .pipe( 
                        map( (result: Booking) => { 
                            //if(carCriteria !== null)
                                return RentActions.bookingUpsertSuccess ( { booking: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });
    /*
    updateBooking$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(RentActions.bookingUpdateSubmit),
            concatMap( (action) => {
                return this.rentService
                    .updateBooking (action.booking)
                    .pipe( 
                        map( (result: Booking) => { 
                            
                                return RentActions.bookingUpsertSuccess ( { booking: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });
    */

    executeBookingAction$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(RentActions.bookingActionSubmit),
            concatMap( (action) => {
                return this.rentService
                    .executeBookingAction (action.bookingAction, action.booking)
                    .pipe( 
                        map( (result: Booking) => { 
                            
                                return RentActions.bookingUpsertSuccess ( { booking: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateBookingStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(RentActions.bookingStatusUpdateSubmit),
            concatMap( (action) => {
                return this.rentService
                    .updateBookingStatus (action.bookingId, action.status)
                    .pipe( 
                        map( (result: Booking) => { 
                            
                                return RentActions.bookingUpsertSuccess ( { booking: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

}